import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import ExamQuizQuestionsResults from "@/components/quiz/ExamQuizQuestionsResults.vue";
let ExamQuizResults = class ExamQuizResults extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterTitle", void 0);
    _defineProperty(this, "questions", void 0);
    _defineProperty(this, "userAnswers", void 0);
    _defineProperty(this, "successRate", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "hideAnswers", void 0);
  }
};
__decorate([Prop({
  required: true
})], ExamQuizResults.prototype, "chapterTitle", void 0);
__decorate([Prop({
  required: true
})], ExamQuizResults.prototype, "questions", void 0);
__decorate([Prop({
  required: true
})], ExamQuizResults.prototype, "userAnswers", void 0);
__decorate([Prop({
  required: true
})], ExamQuizResults.prototype, "successRate", void 0);
__decorate([Prop({
  default: false
})], ExamQuizResults.prototype, "isSpeachTemplate", void 0);
__decorate([Prop({
  default: false
})], ExamQuizResults.prototype, "canEdit", void 0);
__decorate([Prop({
  default: false
})], ExamQuizResults.prototype, "hideAnswers", void 0);
ExamQuizResults = __decorate([Component({
  components: {
    ExamQuizQuestionsResults,
    QuizReadonlyAlert,
    QuizCheckableTextQuestion
  }
})], ExamQuizResults);
export default ExamQuizResults;